import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import Footer from "../common/Footer";
import Header from "../common/Header";
import { useSelector } from "react-redux";
import Sidebar from "../common/Sidebar";
import Toaster from "../common/Toaster";
import QrScanner from "../common/Html5QrcodeScannerComponent";
import Capture from "../common/Capture";
import Loader from "../common/Loader";
import PhysicalMeasurements from "./PhysicalMeasurements";
import ComplianceChecks from "./ComplianceChecks";
import {
  GET_DOOR_TYPES,
  GENERATEQRCODE_API,
  SAVE_SURVEY_FORM_DATA,
  UPLOAD_IMAGE_API,
  DELETE_IMAGE_API,
  GET_ANONYMOUS_INSPECTION_DATA,
  GET_NEXT_REF_NUMBER,
} from "../../api/apiPath";
import http from "../../api/server";
import { hostName } from "../../config/config";
const COMPLIANCE_CHECK = {
  intumescentStrips: true,
  intumescentStripsTimeline: "Select",
  intumescentStripsSeverity: "Select",
  intumescentStripsComments: "",
  intumescentStripsCategory: "Select",
  intumescentStripsDueDate: "",
  intumescentStripsRemediation: "",
  intumescentStripsName: "Are there intumescent strips?",
  intumescentStripsId: "927da4a9-3c0b-46a7-8fb2-00af566a41e6",
  coldSmokeSeals: true,
  coldSmokeSealsTimeline: "Select",
  coldSmokeSealsSeverity: "Select",
  coldSmokeSealsComments: "",
  coldSmokeSealsCategory: "Select",
  coldSmokeSealsDueDate: "",
  coldSmokeSealsRemediation: "",
  coldSmokeSealsName: "Are there cold smoke seals?",
  coldSmokeSealsId: "2d46bbc6-3a52-48ee-ad7d-80c3f3cdf352",
  selfClosingDevice: true,
  selfClosingDeviceTimeline: "Select",
  selfClosingDeviceSeverity: "Select",
  selfClosingDeviceComments: "",
  selfClosingDeviceCategory: "Select",
  selfClosingDeviceDueDate: "",
  selfClosingDeviceRemediation: "",
  selfClosingDeviceName: "Self closing device?",
  selfClosingDeviceId: "145baf7e-bcc6-4c8f-b925-070e751ba2d6",
  fireLockedSign: true,
  fireLockedSignTimeline: "Select",
  fireLockedSignSeverity: "Select",
  fireLockedSignComments: "",
  fireLockedSignCategory: "Select",
  fireLockedSignDueDate: "",
  fireLockedSignRemediation: "",
  fireLockedSignName: "Fire door Keep Locked sign?",
  fireLockedSignId: "942c7963-7d98-49db-a13e-63ee7b4fcfd1",
  fireShutSign: true,
  fireShutSignTimeline: "Select",
  fireShutSignSeverity: "Select",
  fireShutSignComments: "",
  fireShutSignCategory: "Select",
  fireShutSignDueDate: "",
  fireShutSignRemediation: "",
  fireShutSignName: "Fire door Keep Shut sign?",
  fireShutSignId: "b7157137-2bfc-423d-b236-6620c527519b",
  holdOpenDevice: true,
  holdOpenDeviceName: "Is there a hold open device?",
  holdOpenDeviceId: "a106ba4e-ef40-4510-851e-09d1315becc5",
  visibleCertification: true,
  visibleCertificationName: "Is certification visible on fire door?",
  visibleCertificationId: "99ab902f-794a-491b-a6e3-26c8a57f9527",
  doorGlazing: true,
  doorGlazingName: "Does the door contain glazing?",
  doorGlazingId: "1b2886cc-a1a3-4573-a5be-7df68c0db109",
  pyroGlazing: true,
  pyroGlazingTimeline: "Select",
  pyroGlazingSeverity: "Select",
  pyroGlazingComments: "",
  pyroGlazingCategory: "Select",
  pyroGlazingDueDate: "",
  pyroGlazingRemediation: "",
  pyroGlazingName: "Is glazing pyro glazing?",
  pyroGlazingId: "c9873267-e600-4c99-bf08-088dee277909",
};
const FORM_DATA = {
  buildingName: "",
  doorLocation: "",
  doorNumber: "",
  doorType: "Select",
  doorTypeName: "",
  doorOther: "",
  doorPhotos: [],
  fireResistance: "Select",
  head: null,
  headTimeline: "Select",
  headSeverity: "Select",

  headComments: "",
  headCategory: "Select",
  headDueDate: "",
  headRemediation: "",
  headPredefined: "",
  hinge: null,
  hingeLocation: "Select",
  hingeTimeline: "Select",
  hingeSeverity: "Select",
  hingeComments: "",
  hingeCategory: "Select",
  hingeDueDate: "",
  hingeRemediation: "",
  hingePredefined: "",
  closing: null,
  closingTimeline: "Select",
  closingSeverity: "Select",
  closingComments: "",
  closingCategory: "Select",
  closingDueDate: "",
  closingRemediation: "",
  closingPredefined: "",
  threshold: null,
  thresholdTimeline: "Select",
  thresholdSeverity: "Select",
  thresholdComments: "",
  thresholdCategory: "Select",
  thresholdDueDate: "",
  thresholdRemediation: "",
  thresholdPredefined: "",
  doorThickness: null,
  frameDepth: null,
  doorSize: null,
  fullDoorsetSize: null,
};
const BASE_MEASURES = {
  head: 3,
  hinge: 3,
  closing: 3,
  threshold: 3,
};
const BASE_MEASURES_COMP = {
  intumescentStrips: true,
  coldSmokeSeals: true,
  fireLockedSign: true,
  fireShutSign: true,
  pyroGlazing: true,
};

const ACTION_MENU_FLAG = {
  head: false,
  hinge: false,
  closing: false,
  threshold: false,
  intumescentStrips: false,
  coldSmokeSeals: false,
  selfClosingDevice: false,
  fireLockedSign: false,
  fireShutSign: false,
  pyroGlazing: false,
};
const ACTION_MENU_IMAGES = {
  head: [],
  hinge: [],
  closing: [],
  threshold: [],
  intumescentStrips: [],
  coldSmokeSeals: [],
  selfClosingDevice: [],
  fireLockedSign: [],
  fireShutSign: [],
  pyroGlazing: [],
};

const Dashboard = () => {
  const navigate = useNavigate();
  // const location = useParams();
  // const { propertyMasterId } = location;
  const [propertyMasterId, setPropertyMasterId] = useState(null);
  const [qrCode, setQrCode] = useState("");
  const [doorOtherFlag, setDoorOtherFlag] = useState(false);
  const [isGlazing, setIsGlazing] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isColdSeals, setIsColdSeals] = useState(false);
  const [isFireKeepLocked, setFireKeepLocked] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceCheck, setComplianceCheck] = useState(COMPLIANCE_CHECK);
  const [validationFlag, setValidationFlag] = useState(false);
  const [actionmenuFlag, setActionMenuFlag] = useState([]);
  const [actionImages, setActionImages] = useState(ACTION_MENU_IMAGES);
  const [error, setError] = useState(null);
  const [ShowScanQRCode, setShowScanQRCode] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [doorTypesOption, setDoorTypesOption] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  const [resetCaptureFlag, setResetCaptureFlag] = useState(false);
  const [formData, setFormData] = useState(FORM_DATA);
  const [floorPlanImages, setFloorPlanImages] = useState([]);

  const [basicFormData, setBasicFormData] = useState({
    buildingName: "",
    propertyImage: [],
    uniqueRef: "",
    date: new Date().toISOString().split("T")[0],
    location: "",
    floor: null,
    comment: "",
    floorPlan: [],
  });

  const mandatoryFieldRef = useRef({});

  useEffect(() => {
    setIsloading(true);
    setPropertyMasterId(null);

    const fetchData = async () => {
      await fetchPropertyData();
    };
    fetchData();
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  }, []);

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const fetchPropertyData = async () => {
    try {
      const response = await http.get(GET_DOOR_TYPES);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.data;
      setDoorTypesOption(dataResponse);
      console.log("door types", dataResponse);
      if (userObj) {
        const response1 = await http.get(
          GET_ANONYMOUS_INSPECTION_DATA + userObj?.userEmail
        );
        if (!response1.status) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
        const dataResponse1 = await response1?.data;
        console.log("data", dataResponse1);
      }
      if (propertyMasterId !== null && propertyMasterId !== undefined ) {
        const nextRefNumber = await getNextRefNumber();
        setFormData({
          ...formData,
          doorNumber: await CreateDoorReference(
            basicFormData.buildingName,
            nextRefNumber
          ),
        });
      }
      setIsloading(false);
      return dataResponse;
    } catch (error) {
      setError(error?.data);
      setIsloading(false);
      // console.error("Failed to load fetch Property data:", error);
      return {};
    }
  };
  const CreateDoorReference = async (propertyName, nextRefNumber) => {
    let doorRefNumber = "";
    if (propertyName != undefined && propertyName != null) {
      doorRefNumber =
        userObj.userName
          .split(" ")
          .filter((word) => word)
          .map((word) => word[0].toUpperCase())
          .join("") +
        "-" +
        propertyName
          .split(" ")
          .filter((word) => word)
          .map((word) => word[0].toUpperCase())
          .join("") +
        "-DRN-" +
        String(nextRefNumber).padStart(4, "0");
    }
    return doorRefNumber;
  };

  const getNextRefNumber = async () => {
    if (propertyMasterId != null || propertyMasterId != "") {
      try {
        const response1 = await http.get(
          GET_NEXT_REF_NUMBER + propertyMasterId + "/" + basicFormData.inspectorId
        );
        if (response1.data == "Property user mapping not found") {
          throw new Error(
            "You don't have an assigned property. Please contact admin"
          );
        }
        if (!response1.status) {
          throw new Error(`HTTP error! status: ${response1?.status}`);
        }
        let NextRefNumber = await response1.data.nextRefNumber;
        return NextRefNumber;
      } catch (error) {
        setError(error?.data);
        setIsloading(false);
        // console.error("Failed to load fetch Property data:", error);
        return {};
      }
    }
  };

  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  const uploadImageAPI = async (newImages, field) => {
    const latestImage = newImages[newImages.length - 1];
    const file = base64ToFile(latestImage, `${field}_Image_${Date.now()}.jpg`);
    const formDataToUpload = new FormData();
    formDataToUpload.append("File", file);
    formDataToUpload.append("Client", "ABC"); // Use actual values from state/context if needed
    formDataToUpload.append("Property", "Candor");
    formDataToUpload.append("InspectionDate", new Date().toISOString());
    try {
      const response = await fetch(hostName + UPLOAD_IMAGE_API, {
        method: "POST",
        body: formDataToUpload,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      // const response = await http.post(UPLOAD_IMAGE_API,
      //    formDataToUpload,
      //    {headers: {"Content-Type": "multipart/form-data"}})
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.json();
      return dataResponse?.result.blobUrl;
    } catch (error) {
      setError(error?.data);
      return {};
    }
  };

  const deleteImageAPI = async (imageToDelete) => {
    try {
      const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      setError(error?.data);
    }
  };
  const handleDeleteImages = (indexToRemove, field) => {
    let imageToDelete = "";
    if (field === "Additional") {
      imageToDelete = floorPlanImages[indexToRemove];
      const combined = floorPlanImages.filter(
        (_, index) => index !== indexToRemove
      );
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.value = "";
      imageToDelete = formData.doorPhotos[indexToRemove];
      const imgArr = formData.doorPhotos;
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.value = "";
      imageToDelete = basicFormData.floorPlan[indexToRemove];
      const imgArr = basicFormData.floorPlan;
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    }else if (field === "Property") {
      mandatoryFieldRef.current.propertyFile.value = "";
      imageToDelete = basicFormData.propertyImage[indexToRemove];
      const imgArr = basicFormData.propertyImage;
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setBasicFormData({
        ...basicFormData,
        propertyImage: combined,
      });
      resetIndvidualField("propertyFile");
    } else {
      const imgArr = actionImages[field];
      imageToDelete = imgArr[indexToRemove];
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setActionImages({
        ...actionImages,
        [field]: combined,
      });
    }
    deleteImageAPI(imageToDelete);
  };

  const handleComplianceToggle = (e) => {
    if (e.target.name === "selfClosingDevice") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          selfClosingDevice: e.target.checked,
        };
      });
      setFireKeepLocked(!e.target.checked);
    } else if (e.target.name === "fireLockedSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireLockedSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireLockedSign: !e.target.checked,
      });
    } else {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          [e.target.name]: e.target.checked,
        };
      });
      if (e.target.checked != BASE_MEASURES_COMP[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }

    if (e.target.name === "doorGlazing") {
      if (e.target.checked === true) {
        setIsGlazing(true);
        if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: false,
          });
        }
      } else {
        setIsGlazing(false);
        setActionMenuFlag({
          ...actionmenuFlag,
          pyroGlazing: false,
        });
      }
    }
  };

  const resetIndvidualField = (field) => {
    mandatoryFieldRef.current[field] != null
      ? (mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6")
      : null;
  };

  const resetMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "buildingName",
        "location",
        "floor",
        "doorLocation",
        "doorType",
        "doorOther",
        "head",
        "hingeLocation",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "floorFile",
        "doorFile",
      ];
    } else {
      newArr = [
        "buildingName",
        "location",
        "floor",
        "doorLocation",
        "doorType",
        "head",
        "hingeLocation",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "floorFile",
        "doorFile",
      ];
    }
    newArr.forEach((elem) => {
      mandatoryFieldRef.current[elem] != null
        ? (mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6")
        : null;
    });
    // for(let key in ACTION_MENU_FLAG) {
    //   if(actionmenuFlag[key] === true){
    //     const tempArr = ["Timeline", "Severity", "Category", "DueDate", "Remediation", "Comments"];
    //     tempArr.forEach((elem) => {
    //       mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6";
    //     })
    //   }
    // }
    mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6";
    mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
  };

  const handleMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "buildingName",
        "location",
        "floor",
        "doorLocation",
        "doorType",
        "doorOther",
        "head",
        "hingeLocation",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "floorFile",
        "doorFile",
      ];
    } else {
      newArr = [
        "buildingName",
        "location",
        "floor",
        "doorLocation",
        "doorType",
        "head",
        "hingeLocation",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "floorFile",
        "doorFile",
      ];
    }
    newArr.forEach((elem) => {
      const test = mandatoryFieldRef.current[elem];
      if (!test.value.trim() || test.value === "Select") {
        mandatoryFieldRef.current[elem].style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6";
      }
    });
    for (let key in ACTION_MENU_FLAG) {
      if (actionmenuFlag[key] === true) {
        const tempArr = ["Severity", "Category", "DueDate", "Remediation"];
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef.current[key + elem];
          if (test != undefined) {
            if (!test.value.trim() || test.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      }
    }
    //for upload files
    if (basicFormData.floorPlan.length === 0) {
      mandatoryFieldRef.current.floorFile.style.border = "2px solid red";
    } else {
      mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6";
    }
    if (formData.doorPhotos.length === 0) {
      mandatoryFieldRef.current.doorFile.style.border = "2px solid red";
    } else {
      mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
    }
  };

  const handleValidationOnSave = (status) => {
    setIsloading(true);
    let validFlag1 = false;
    let validFlag2 = false;
    let validFlag3 = false;
    let validFlag4 = false;
    for (let key in BASE_MEASURES) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === 0
      ) {
        validFlag1 = true;
        break;
      } else if (key === "hinge" && formData.hingeLocation === "Select") {
        validFlag1 = true;
        break;
      } else {
        validFlag1 = false;
      }
    }
    let checkArr = { doorType: "doorType", doorPhotos: "doorPhotos" };
    for (let key in checkArr) {
      if (key === "doorPhotos" && formData[key].length === 0) {
        validFlag2 = true;
        break;
      } else if (key === "doorType") {
        if (
          formData[key] === "4" &&
          (formData.doorOther === "" ||
            formData.doorOther === null ||
            formData.doorOther === undefined)
        ) {
          validFlag2 = true;
          break;
        } else if (formData[key] === "Select") {
          validFlag2 = true;
          break;
        }
      } else {
        validFlag2 = false;
      }
    }
    let phyArr = {
      doorThickness: null,
      frameDepth: null,
      doorSize: null,
      fullDoorsetSize: null,
    };
    for (let key in phyArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === 0
      ) {
        validFlag4 = true;
        break;
      } else {
        validFlag4 = false;
      }
    }
    let validFlag5 = false;
    if (
      basicFormData.floorPlan.length === 0 ||
      basicFormData.floor === undefined ||
      basicFormData.floor === null ||
      basicFormData.floor === ""
    ) {
      validFlag5 = true;
    } else {
      validFlag5 = false;
    }
    //check door location
    let validFlag6;
    if (
      formData.doorLocation === "" ||
      formData.doorLocation === undefined ||
      formData.doorLocation === null
    ) {
      validFlag6 = true;
    } else {
      validFlag6 = false;
    }
    //building name and location validation
    let validFlag7;
    if (
      basicFormData.buildingName === "" ||
      basicFormData.buildingName === undefined ||
      basicFormData.buildingName === null ||
      basicFormData.location === "" ||
      basicFormData.location === undefined ||
      basicFormData.location === null
    ) {
      validFlag7 = true;
    } else {
      validFlag7 = false;
    }
    if (
      validFlag1 ||
      validFlag2 ||
      validFlag3 ||
      validFlag4 ||
      validFlag5 ||
      validFlag6 ||
      validFlag7
    ) {
      setValidationFlag(true);
      handleMandatoryFields();
      setIsloading(false);
    } else {
      setValidationFlag(false);
      handleSubmit(status);
    }
  };
  const handleSubmit = async (status) => {
    //Create payload for API

    const phyGaps = ["head", "hinge", "closing", "threshold"];
    let newObj = {
      fireRatingID: formData.fireResistance ? formData.fireResistance : "",
      comments: basicFormData.comment,
      hingePosition: formData.hingeLocation,
    };
    phyGaps.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: actionmenuFlag[elem] ? "yes" : "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
      };
      newObj[elem] = newObj1;
    });
    const phyMeasures = [
      "doorThickness",
      "frameDepth",
      "doorSize",
      "fullDoorsetSize",
    ];
    phyMeasures.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
      };
      newObj[elem] = newObj1;
    });

    const compArr = [
      "intumescentStrips",
      "coldSmokeSeals",
      "selfClosingDevice",
      "fireLockedSign",
      "fireShutSign",
      "holdOpenDevice",
      "visibleCertification",
      "doorGlazing",
      "pyroGlazing",
    ];
    let newArr = [];
    compArr.forEach((item) => {
      if (item === "fireLockedSign") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: !isFireKeepLocked
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
              }
            : complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
              }
            : {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: actionImages[item],
              },
        };
        newArr.push(newObj2);
      } else {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
              }
            : {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: actionImages[item],
              },
        };
        newArr.push(newObj2);
      }
    });

    let doorImgObj = {};
    for (let key = 1; key <= formData.doorPhotos.length; key++) {
      let name = "Image " + key + " Path";
      doorImgObj[name] = formData.doorPhotos[key - 1];
    }

    const fullFormData = {
      masterProperty: {
        propertyName: basicFormData.buildingName,
        propertyLocation: basicFormData.location,
        createdBy: userObj.userEmail,
        updatedBy: userObj.userEmail,
        propertyImage: basicFormData.propertyImage
          ? basicFormData.propertyImage[0]
          : "no image",
      },
      propertyInfo: {
        propertyMasterId: "f204c245-37d1-4650-919f-d9aed1234567", //dummy ID
        inspectionStartedOn: basicFormData.date,
        inspectedBy: userObj.userName,
        InspectedById: userObj.userId,
        inspectionApprovedDate: null,
        lastInspectionDate: new Date().toISOString(),
        inspectionApprovedBy: "",
        lastInspectedBy: userObj.userName,
        status: status,
        inspectionUpdatedBy: userObj.userName,
        inspectionUpdatedOn: new Date().toISOString(),
        nextInspectionDueDate: null,
      },
      inspectedPropertyFloorsInfo: {
        floorNo:
          basicFormData.floor != undefined ? Number(basicFormData.floor) : null,
        floorPlanImage: basicFormData.floorPlan
          ? basicFormData.floorPlan[0]
          : "no image",
        createdBy: userObj?.userEmail,
        updatedBy: userObj?.userEmail,
      },
      inspectedDoorDto: {
        doorTypeId: formData.doorType ? formData.doorType : "",
        doorRefNumber: formData.doorNumber ? formData.doorNumber : "",
        doorNumber: formData.doorNumber ? formData.doorNumber : "",
        floorNo:
          basicFormData.floor != undefined ? Number(basicFormData.floor) : null,
        floorImage: basicFormData.floorPlan
          ? basicFormData.floorPlan[0]
          : "no image",
        inspectedBy: userObj.userName,
        doorInspectionDate: basicFormData.date,
        status: "",
        flatName: "",
        doorTypeName: formData.doorTypeName ? formData.doorTypeName : "",
        propertyName: basicFormData.buildingName
          ? basicFormData.buildingName
          : "",
        otherDoorTypeName: formData.doorOther,
        doorLocation: formData.doorLocation,
        doorPhoto: doorImgObj,
      },
      complianceChecks: newArr,
      physicalMeasurement: newObj,
      additionalInfos: [
        {
          imagePath: floorPlanImages,
        },
      ],
    };

    // Submit formData to API
    const response = await saveData(JSON.stringify(fullFormData));
    console.log("res,", response)
    if (response.status === 200) {
      setToastData({
        toastShow: true,
        toastType: "success",
        toastString:
          "Your inspection for Door reference Number: " +
          formData.doorNumber + "in building with reference number: " +
          response?.data.propertyUniqueRefNumber + 
          " has been saved successfully.",
      });
      setTimeout(() => loadNewForm(response?.data), 3000);
    } else {
      setIsloading(false);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Error in saving data, please try again",
      });
    }
  };

  const saveData = async (allData) => {
    try {
      const response = await http.post(SAVE_SURVEY_FORM_DATA, allData);
      return response;
    } catch (error) {
      return error;
    }
  };

  const loadNewForm = async (response) => {
    setIsloading(true);
    setPropertyMasterId(response.propertyMasterId);
    setBasicFormData({
      ...basicFormData,
      uniqueRef: response.propertyUniqueRefNumber,
      inspectorId:  response.inspectorId
    })
    await fetchPropertyData();
    await handleFormReset();
    setTimeout(
      () =>
        setToastData({
          toastShow: true,
          toastString:
            "Survey is now refreshed for new door. Please continue for new next door.",
          toastType: "success",
        }),
      500
    );
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; }
            .print-container { text-align: center; }
            .modal-header { background-color: gray; color: white; padding: 10px; }
          </style>
        </head>
        <body>
          <div class="print-container" style="margin-top:100px">
            <img src="${qrCode}" alt="QR Code" height='400px' width='400px' />
            <h3>Door Reference Number: ${formData.doorNumber}</h3>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const handleFormDataChange = (e) => {
    resetIndvidualField(e.target.name);
    if (e.target.name === "doorType") {
      const doorTypeName = e.target.options[e.target.selectedIndex].text;
      setFormData({
        ...formData,
        doorTypeName: doorTypeName,
        [e.target.name]: e.target.value,
      });
      if (doorTypeName === "Other") {
        setDoorOtherFlag(true);
      } else {
        setDoorOtherFlag(false);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };
  const handleFireResistanceChange = (e) => {
    setFormData({
      ...formData,
      fireResistance: e.target.value,
    });
    if (e.target.value === "1") {
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold < 10
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    } else {
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold != BASE_MEASURES.threshold
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    }
    if (
      e.target.value === "5" ||
      e.target.value === "6" ||
      e.target.value === "7"
    ) {
      setIsColdSeals(true);
    } else {
      setIsColdSeals(false);
    }
  };

  const handleGapsChange = (e) => {
    resetIndvidualField(e.target.name);
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "threshold") {
      if (formData.fireResistance === "1") {
        if (e.target.value < 10) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      } else {
        if (e.target.value > BASE_MEASURES[e.target.name]) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      }
    } else {
      if (e.target.value > BASE_MEASURES[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }
  };

  const handleChange = async (e) => {
    if (e.target.name === "floor") {
      console.log("flor", e.target.name, e.target.value);
      resetIndvidualField(e.target.name);
      const { name, value } = e.target;
      setBasicFormData({
        ...basicFormData,
        [name]: value,
      });
    } else if (e.target.name === "comment") {
      let val = removeSpecialCharacters(e.target.value);
      setBasicFormData({ ...basicFormData, comment: val });
    } else if (e.target.name === "buildingName") {
      resetIndvidualField(e.target.name);
      const { name, value } = e.target;
      setBasicFormData({ ...basicFormData, [name]: value });
      if (propertyMasterId === null) {
        setFormData({
          ...formData,
          doorNumber: await CreateDoorReference(e.target.value, 1001),
        });
      }
    } else {
      if (e.target.name === "location") {
        resetIndvidualField(e.target.name);
      }
      const { name, value } = e.target;
      setBasicFormData({ ...basicFormData, [name]: value });
    }
  };

  const handleImagesChange = async (newImages, field) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    if (field === "Additional") {
      const combined = [...floorPlanImages, ...newArr];
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      const imgArr = formData.doorPhotos;
      const combined = [...imgArr, ...newArr];
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6";
      const imgArr = basicFormData.floorPlan;
      const combined = [...imgArr, ...newArr];
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    }else if( field === "Property"){
      mandatoryFieldRef.current.propertyFile.style.border = "1px solid #dee2e6";
      const imgArr = basicFormData.propertyImage;
      const combined = [...imgArr, ...newArr];
      setBasicFormData({
        ...basicFormData,
        propertyImage: combined,
      });
      resetIndvidualField("propertyFile");
    }
  };

  const generateQRCode = async () => {
    try {
      setShowModal(true);
      setShowLoader(true);
      let data = window.location.origin + "/editSurvey/" + formData.doorNumber;
      const qrCodeUrl = await http.get(GENERATEQRCODE_API + data);
      setQrCode(qrCodeUrl.data.qrCode);
      setShowLoader(false);
    } catch (error) {
      throw new Error(`HTTP error! status: ${error}`);
    } finally {
      setShowLoader(false);
    }
    setShowModal(true);
  };

  const removeSpecialCharacters = (input) => {
    return input.replace(/[^a-zA-Z0-9 !?.,"'() & :; -]/g, ""); // Keeps letters, numbers, and spaces
  };

  const handleFormReset = () => {
    //red highlights reset
    setTimeout(() => resetMandatoryFields(), 100);
    setFormData((prev) => ({
      ...prev,

      // General
      doorLocation: "",
      doorType: "1",
      doorOther: "",
      doorPhotos: [],
      fireResistance: "",

      // PHYSICAL MEASUREMENTS - GAPS
      head: "",
      headTimeline: "Select",
      headSeverity: "Select",
      headComments: "",
      headCategory: "Select",
      headDueDate: "",
      headRemediation: "",

      hinge: "",
      hingeLocation: "Select",
      hingeTimeline: "Select",
      hingeSeverity: "Select",
      hingeComments: "",
      hingeCategory: "Select",
      hingeDueDate: "",
      hingeRemediation: "",

      closing: "",
      closingTimeline: "Select",
      closingSeverity: "Select",
      closingComments: "",
      closingCategory: "Select",
      closingDueDate: "",
      closingRemediation: "",

      threshold: "",
      thresholdTimeline: "Select",
      thresholdSeverity: "Select",
      thresholdComments: "",
      thresholdCategory: "Select",
      thresholdDueDate: "",
      thresholdRemediation: "",

      doorThickness: "",
      frameDepth: "",
      doorSize: "",
      fullDoorsetSize: "",
    }));

    // Basic info reset
    setBasicFormData((prev) => ({
      ...prev,
      location: "",
      propertyImage:[],
      date: new Date().toISOString().split("T")[0],
      floor: "",
      comment: "",
      floorPlan: [],
    }));

    // Other resets
    setFloorPlanImages([]);
    setComplianceCheck(COMPLIANCE_CHECK);
    setActionMenuFlag(ACTION_MENU_FLAG);
    setActionImages(ACTION_MENU_IMAGES);
    setDoorOtherFlag(false);
    complianceCheck.doorGlazing ? setIsGlazing(true) : setIsGlazing(false);
    setValidationFlag(false);
    setFireKeepLocked(false);
    setIsColdSeals(false);

    // MiniCapture reset flag
    setResetCaptureFlag(true);
    setTimeout(() => setResetCaptureFlag(false), 100);
  };

  const { userObj } = useSelector((state) => state.user);
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link to="/">Go back to Login</Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <Loader active={isLoading} />
          {hideSidebar && <Sidebar />}
          {showModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span>
                <h6 className="modal-header">
                  {formData.buildingName} / {formData.doorNumber}
                </h6>{" "}
                {/* Modal Header */}
                <div className="modal-body">
                  {showLoader ? (
                    <div
                      className="approvalLoader"
                      style={{ marginLeft: "45%" }}
                    ></div>
                  ) : (
                    qrCode && (
                      <img
                        src={qrCode}
                        alt="QR Code"
                        style={{ height: "80%", width: "50%" }}
                      />
                    )
                  )}
                  {!showLoader && (
                    <div style={{ marginTop: "20px" }}>
                      <button
                        className="btn btn-primary"
                        style={{ minHeight: "20px" }}
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="d-flex dashboard_body flex-column py-3 ">
            <form className="row m-0">
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <div className="card">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Basic Information</p>
                    </div>

                    <div className="form-floating mb-3">
                      <input
                        ref={(el) =>
                          (mandatoryFieldRef.current.buildingName = el)
                        }
                        type="text"
                        className="form-control"
                        id="buildingName"
                        name="buildingName"
                        value={basicFormData.buildingName}
                        onChange={handleChange}
                      />
                      <label htmlFor="buildingName">
                        Building Name<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>

                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="uniqueRef"
                        name="uniqueRef"
                        disabled
                        placeholder="JN1234"
                        value={basicFormData.uniqueRef}
                      />
                      <label htmlFor="uniqueRef">
                        Unique Building Reference
                      </label>
                    </div>

                    <div className="form-floating mb-3">
                      <input
                        type="date"
                        className="form-control"
                        id="date"
                        name="date"
                        value={basicFormData.date}
                        onChange={(e) => handleChange(e)}
                      />
                      <label htmlFor="date">Date</label>
                    </div>

                    <div className="form-floating mb-3">
                      <textarea
                        ref={(el) => (mandatoryFieldRef.current.location = el)}
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Location"
                        id="location"
                        name="location"
                        onChange={(e) => handleChange(e)}
                        value={basicFormData.location}
                      ></textarea>
                      <label htmlFor="location">
                        Location<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>

                    <div className="form-floating mb-3">
                      <div className="d-flex gap-3 flex-wrap">
                        <label htmlFor="floorPlan">
                          Upload Property Image
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Capture
                          onImagesChange={(images) =>
                            handleImagesChange(images, "Property")
                          }
                          savedImages={basicFormData.propertyImage}
                          reset={resetCaptureFlag}
                          onImageDelete={(index) =>
                            handleDeleteImages(index, "Property")
                          }
                          mandatoryFieldRef={mandatoryFieldRef}
                          fieldValue={"propertyFile"}
                          singleImageCapture
                          isView={false}
                        />
                      </div>
                    </div>

                    <div className="form-floating mb-3">
                      <input
                        ref={(el) => (mandatoryFieldRef.current.floor = el)}
                        type="number"
                        pattern="[0-9]*"
                        inputMode="numeric"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "e" || e.key === ".") {
                            e.preventDefault(); // Prevent invalid characters
                          }
                        }}
                        className="form-control"
                        id="floor"
                        name="floor"
                        value={basicFormData.floor}
                        placeholder="Enter positive number"
                        min={0}
                        step={1}
                        onChange={(e) => handleChange(e)}
                      />
                      <label htmlFor="floor">
                        Floor<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>

                    <div className="form-floating mb-3">
                      <div className="d-flex gap-3 flex-wrap">
                        <label htmlFor="floorPlan">
                          Upload Floor Plan
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Capture
                          onImagesChange={(images) =>
                            handleImagesChange(images, "Floor")
                          }
                          savedImages={basicFormData.floorPlan}
                          reset={resetCaptureFlag}
                          onImageDelete={(index) =>
                            handleDeleteImages(index, "Floor")
                          }
                          mandatoryFieldRef={mandatoryFieldRef}
                          fieldValue={"floorFile"}
                          singleImageCapture
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 mb-3 border p-3 rounded">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          ref={(el) =>
                            (mandatoryFieldRef.current.doorLocation = el)
                          }
                          className="form-control"
                          id="floatingInputValue"
                          name="doorLocation"
                          value={formData.doorLocation}
                          onChange={(e) => {
                            handleFormDataChange(e);
                          }}
                        />
                        <label htmlFor="floatingInputValue">
                          Door Location<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="floatingInputValue"
                          name="doorNumber"
                          disabled
                          onChange={handleFormDataChange}
                          value={formData.doorNumber}
                        />
                        <label htmlFor="floatingInputValue">Door Number</label>
                      </div>
                      <div className="form-floating mb-3">
                        <select
                          ref={(el) =>
                            (mandatoryFieldRef.current.doorType = el)
                          }
                          className="form-select"
                          name="doorType"
                          id="floatingSelect"
                          aria-label="Floating label select example"
                          value={formData.doorType}
                          onChange={(e) => {
                            handleFormDataChange(e);
                          }}
                        >
                          <option selected>Select</option>
                          {doorTypesOption.map((type) => (
                            <option
                              key={type.doorTypeName}
                              value={type.doorTypeId}
                            >
                              {type.doorTypeName}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="floatingSelect">
                          Door Type<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      {doorOtherFlag && (
                        <div className="form-floating mb-3">
                          <input
                            type="text"
                            ref={(el) =>
                              (mandatoryFieldRef.current.doorOther = el)
                            }
                            className="form-control"
                            id="floatingInputValue"
                            name="doorOther"
                            value={formData.doorOther}
                            onChange={(e) => {
                              handleFormDataChange(e);
                            }}
                          />
                          <label htmlFor="floatingInputValue">
                            Other<span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                      )}
                      <div className="form-floating mb-3">
                        <div className="d-flex gap-3 flex-wrap">
                          <label htmlFor="floorPlan">
                            Upload Door Photo
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <br></br>
                          <Capture
                            onImagesChange={(images) =>
                              handleImagesChange(images, "Door")
                            }
                            reset={resetCaptureFlag}
                            onImageDelete={(index) =>
                              handleDeleteImages(index, "Door")
                            }
                            mandatoryFieldRef={mandatoryFieldRef}
                            fieldValue={"doorFile"}
                            singleImageCapture
                          />
                        </div>
                      </div>
                      <div className="col-sm-12">
                        <div className="col-12 d-flex gap-3 flex-wrap">
                          <button
                            type="button"
                            className="btn btn-secondary w-auto w-100 flex-grow-1"
                            onClick={() => generateQRCode()}
                          >
                            Generate QR Code
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary w-auto w-100 flex-grow-1"
                            onClick={() => setShowScanQRCode(!ShowScanQRCode)}
                          >
                            {ShowScanQRCode
                              ? "Close Scan QR Code"
                              : "Scan QR Code"}
                          </button>
                          {ShowScanQRCode && (
                            <QrScanner renderInComponent={true} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">
                        Fire Rating and certification{" "}
                      </p>
                    </div>
                    <div className="form-floating">
                      <select
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={formData.fireResistance}
                        onChange={handleFireResistanceChange}
                      >
                        <option selected>Select</option>
                        <option value="1">FD30</option>
                        <option value="2">FD60</option>
                        <option value="3">FD90</option>
                        <option value="4">FD120</option>
                        <option value="5">FD30S</option>
                        <option value="6">FD60S</option>
                        <option value="7">FD90S</option>
                        <option value="8">FD120S</option>
                      </select>
                      <label htmlFor="floatingSelect">Fire Resistance</label>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <PhysicalMeasurements
                    mandatoryFieldRef={mandatoryFieldRef}
                    formData={formData}
                    OnhandleFormDataChange={handleFormDataChange}
                    OnhandleGapsChange={handleGapsChange}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-lg-4 mb-3">
                <div className="card mb-4">
                  <ComplianceChecks
                    isGlazing={isGlazing}
                    OnhandleComplianceToggle={handleComplianceToggle}
                    complianceCheck={complianceCheck}
                    isColdSeals={isColdSeals}
                    isFireKeepLocked={isFireKeepLocked}
                  />
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Photos</p>
                    </div>
                    <div className="form-floating">
                      <div className="col-sm-12 mb-3">
                        <div className="d-flex gap-3 flex-wrap">
                          <Capture
                            onImagesChange={(images) =>
                              handleImagesChange(images, "Additional")
                            }
                            onImageDelete={(index) =>
                              handleDeleteImages(index, "Additional")
                            }
                            reset={resetCaptureFlag}
                            mandatoryFieldRef={mandatoryFieldRef}
                            fieldValue={"additionalFile"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Comments</p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        // value="Comments"
                        id="floatingTextarea"
                        name="comment"
                        value={basicFormData.comment}
                        onChange={(e) => handleChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mb-3">
                <div className="card">
                  {validationFlag && (
                    <span style={{ color: "red" }}>
                      Please fill all required fields
                    </span>
                  )}
                  <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                    {/* <button
                      type="button"
                      className="btn btn-primary"
                      style={{ marginRight: "auto" }}
                      onClick={() => handleValidationOnSave("Completed")}
                    >
                      Submit for approval
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-tertiary"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => handleFormReset()}
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      disabled={isLoading}
                      className="btn btn-primary"
                      onClick={() => handleValidationOnSave("In Progress")}
                    >
                      Save & Proceed
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
